import { DataGridPro, LicenseInfo, GridToolbar } from "@mui/x-data-grid-pro";
import { useState } from "react";
LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_LICENSE);

export const Table = ({ data, rowSize }) => {
  const { rows, columns, isLoading, redirect } = data;
  const [pageSize, setPageSize] = useState(rowSize);

  return (
    
    <DataGridPro
      getRowId={(row) => row?.system_id}
      sx={dataGrid}
      loading={isLoading}
      rows={rows}
      onCellDoubleClick={redirect}
      density="standard"
      columns={columns}
      pagination
      components={{ Toolbar: GridToolbar }}
      headerHeight={40}
      disableSelectionOnClick
      autoHeight={true}
      pageSize={pageSize}
      rowsPerPageOptions={[5, 10, 25, 50, 100]}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
    />
  );
};

const dataGrid = {
  ".MuiDataGrid-main": {
    background: "#FFFFFF",
  },
  ".MuiDataGrid-columnSeparator": {
    display: "none",
  },
  ".MuiDataGrid-columnHeaders": {
    background: "#F8F8F8",
    border: "1px solid #EBEBEB",
    fontFamily: "Roboto",
    fontSize: "14px",
    lineHeight: "49px",
    color: "#333333",
  },
  ".MuiDataGrid-virtualScroller": {
    marginTop: "42px !important",
  },
  ".MuiDataGrid-columnHeaderTitle": {
    fontWeight: 700,
  },
  ".MuiDataGrid-row": {
    color: "#333",
    background: "#FFFFFF",
  },
  ".MuiDataGrid-row:hover": {
    cursor: "pointer",
    background: "rgba(43, 124, 211, 0.2)",
    transition: "100ms",
  },
  ".MuiSvgIcon-root": {
    color: "#B3B3B3",
  },
  ".MuiTypography-root": {
    fontFamily: "Roboto",
    fontSize: "14px",
    lineHeight: "49px",
    color: "#333333",
  },
};

Table.defaultProps = {
  rowSize: 25
}